/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Log_Out_SubtitleInputs */

const en_common_log_out_subtitle = /** @type {(inputs: Common_Log_Out_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign out of your account`)
};

const es_common_log_out_subtitle = /** @type {(inputs: Common_Log_Out_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar sesión en tu cuenta`)
};

/**
* | output |
* | --- |
* | "Sign out of your account" |
*
* @param {Common_Log_Out_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_log_out_subtitle = /** @type {((inputs?: Common_Log_Out_SubtitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Log_Out_SubtitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_log_out_subtitle(inputs)
	return en_common_log_out_subtitle(inputs)
});